export function mod(a: number, b: number) {
  return ((a % b) + b) % b
}

//just need to check sometimes if two floats are close enough to be considered the same value
export function floatComparator(a: number, b: number, tolerance = 0.000000001) {
  return Math.abs(a - b) <= tolerance ? true : false
}
